import { RouteValidation } from 'src/services/route-validation/RouteValidator';
import ProjectFounderService from 'src/services/route-validation/validators/ProjectFounder';

class RouteValidatorServiceSingleton {
  private static _instance: RouteValidatorServiceSingleton;

  public readonly projectFounder: ProjectFounderService;

  public validate(validations: RouteValidation[]): Promise<void> {
    const reflect = (promise: Promise<void>) => promise.then(
      () => ({status: 'success'}),
      (error: string) => ({payload: error, status: 'failure'})
    );

    const validationPromises = validations.map(validation => {
      return this[validation.type || ''].getValidation();
    });
    return Promise.all(validationPromises.map(reflect)).then(
      (responses: { payload: string, status: string }[]) => {
        if (responses.every(response => response.status === 'success')) {
          return;
        } else {
          const errors = {};
          responses.filter(r => r.status === 'failure').map(r => r.payload).forEach((error: string) => {
            errors[error] = false;
          });

          throw errors;
        }
      },
    );
  }

  public static get instance(): RouteValidatorServiceSingleton {
    return this._instance || (this._instance = new this());
  }

  private constructor() {
    this.projectFounder = new ProjectFounderService();

  }
}

const RouteValidatorService: RouteValidatorServiceSingleton = RouteValidatorServiceSingleton.instance;

export default RouteValidatorService;


// WEBPACK FOOTER //
// ./src/services/route-validation/RouteValidation.service.tsx